module.exports = __webpack_public_path__ + "img/top.14f0861d.png";